export const ExpressionTypes = {
    Good: { path: "assets/animations/good.json", soundSrc: "assets/animations/wav/cheers.wav" },
    Fireworks: { path: "assets/animations/fireworks.json", soundSrc: "assets/animations/wav/fireworks.wav" },
    Like: { path: "assets/animations/like.json", soundSrc: "assets/animations/wav/heart.wav" },
    Trophy: { path: "assets/animations/trophy.json", soundSrc: "assets/animations/wav/trophy.wav" }
}
